import { get } from '../Services/http';
import { catchError } from './Error.action';

export const ADDON_PRODUCT_LOAD = 'ADDON_PRODUCT_LOAD';
export const ADDON_PRODUCT_LOAD_ERROR = 'ADDON_PRODUCT_LOAD_ERROR';
export const ADDON_PRODUCT_RECEIVE = 'ADDON_PRODUCT_RECEIVE';

export const load = (baseProductId) => (dispatch, getState) => {

    var url = '/api/productConfiguration/AddOnForBaseProduct';
    url += '?baseProductId='+baseProductId;

    return get(url)
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadError = error => ({
    type: ADDON_PRODUCT_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = data => {
    return ({
        type: ADDON_PRODUCT_RECEIVE,
        payload: {
            addons: data.addOnSections,
        },
    });
}

export const variantClick = (addon, variant) => (dispatch, getState) => {
    var addons = getState().addons.addons.slice();
    var sel = addons.find(x => x.name == addon);
    var selvar = sel.configVariants.find(x => x.sku == variant);
    if(selvar.selected != true){
        selvar.selected = true;
    } else {
        selvar.selected = false;
    }

    return dispatch(receive({addOnSections : addons}));
}
export const ADDON_SELECTION_SET = 'ADDON_SELECTION_SET';

// The main buy button adds the selected add-ons together with this article.
export const setAddonSelection = (mainArticleNumber, selection) => ({
    type: ADDON_SELECTION_SET,
    payload: { mainArticleNumber, selection },
});
